import { useContext, useState } from 'react'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const usePermissions = () => {
  const [permission, setPermissions] = useState(false)
  const { deleteNewPermission, getNewPermissions } = useContext(SuperAdminContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Permissions', 'ALL_PERMISSIONS', 'GET_ALL_PERMISSIONS')

  const getAllPermissions = async (dto = {}) => {
    console.log({ dto })
    GET_ALL('GET_COMPANY_PERMISSIONS', setPaginate, getNewPermissions, dto)
  }

  const addPermissions = (dto) => {
    ADD('ADD_COMPANY_PERMISSIONS', dto)
  }

  const updatePermissions = (dto) => {
    UPDATE('EDIT_COMPANY_PERMISSIONS', dto)
  }
  
  const getPermission = (dto) => {
    GET_SINGLE_DATA('GET_COMPANY_PERMISSION', setPermissions, dto)
  }

  const deleteManyPermission = (dto, setSelected = () => {}) => {
    DELETE('DELETE_MANY_COMPANY_PERMISSION', dto, 'permissionId', setSelected, ()=>{}, 'GET_COMPANY_PERMISSIONS')
  }

  return {
    addPermissions,
    getAllPermissions,
    getPermission,
    permission,
    updatePermissions,
    deleteManyPermission,
    loading,
    paginate,
  }
}
